import React from 'react';
import styles from '../ReportCard.module.scss';
import { checkBranchesInRange } from '../utils/geo';

/**
 * Панель информации о водителе для оператора (TopBase / CHPP / PrivatePoint).
 * Единый компонент вместо трёх копий.
 *
 * @param {Object} props
 * @param {string}   props.operatorType     — 'topbase' | 'chpp' | 'privatepoint'
 * @param {Object}   props.scannedDriver    — данные водителя
 * @param {Object}   props.lastLoadA        — последняя загрузка
 * @param {boolean}  props.scanLoading
 * @param {string}   props.scanError
 * @param {boolean}  props.confirmLoading
 * @param {string}   props.confirmError
 * @param {string}   props.userGeoLocation
 * @param {Array}    props.operatorBranches
 * @param {Function} props.onConfirm
 */
const OperatorDriverPanel = ({
  operatorType,
  scannedDriver,
  lastLoadA,
  scanLoading,
  scanError,
  confirmLoading,
  confirmError,
  userGeoLocation,
  operatorBranches,
  onConfirm,
}) => {
  // Маппинг по типу оператора
  const typeConfig = {
    topbase: {
      baseLabel: 'База',
      baseName: scannedDriver?.top_base_name || '',
      noLoadMsg: 'Нет погрузки для вашей Базы',
      outOfRangeMsg: 'Необходимо находиться в радиусе 200 метров от одного из филиалов базы',
    },
    chpp: {
      baseLabel: 'ТЭЦ',
      baseName: scannedDriver?.chpp_name || '',
      noLoadMsg: 'Нет погрузки для вашей ТЭЦ',
      outOfRangeMsg: 'Необходимо находиться в радиусе 200 метров от одного из филиалов ТЭЦ',
    },
    privatepoint: {
      baseLabel: 'Частная точка',
      baseName: scannedDriver?.private_point_name || '',
      noLoadMsg: 'Нет погрузки для вашей соц.объекта или МСУ',
      outOfRangeMsg: 'Необходимо находиться в радиусе 200 метров от одного из филиалов соц.объекта или МСУ',
    },
  };
  const config = typeConfig[operatorType] || typeConfig.topbase;

  const showStatus = operatorType !== 'topbase';
  const isInactive = scannedDriver?.status === 'Не активен';

  return (
    <>
      {scanLoading && <div>Загрузка данных водителя...</div>}
      {scanError && <div style={{ color: 'red' }}>{scanError}</div>}
      {scannedDriver && (
        <div className={styles.driverdata}>
          <div><b>ФИО:</b> {scannedDriver.employee_name}</div>
          <div><b>Телефон:</b> {scannedDriver.employee_phone}</div>
          <div><b>Доп. телефон:</b> {scannedDriver.phone}</div>
          <div><b>Авто номер:</b> {scannedDriver.vehicle_number}</div>
          <div><b>Авто модель:</b> {scannedDriver.vehicle_model}</div>
          <div><b>{config.baseLabel}:</b> {config.baseName}</div>
          {showStatus && <div><b>Статус:</b> {scannedDriver.status || 'Свободен'}</div>}

          {showStatus && isInactive && (
            <div style={{ color: 'orange', marginTop: 8, fontWeight: 'bold', fontSize: 16 }}>
              Водитель не активен, обратитесь в администрацию
            </div>
          )}

          {lastLoadA ? (
            <div style={{ marginTop: 8, background: '#f5f5f5', padding: 8, borderRadius: 6 }}>
              <div><b>Последняя загрузка (Кара-Кече):</b></div>
              <div><b>Статус:</b> {lastLoadA.status}</div>
              <div><b>Время въезда:</b> {lastLoadA.time_a}</div>
              <div><b>Отметил (Кара-Кече):</b> {lastLoadA.guard_name || ''}</div>
            </div>
          ) : (
            <div style={{ color: 'red', marginTop: 8 }}>{config.noLoadMsg}</div>
          )}

          {/* Проверка геозоны и кнопка подтверждения */}
          {lastLoadA && (!showStatus || !isInactive) && (() => {
            const { isInRange, distanceInfo } = checkBranchesInRange(userGeoLocation, operatorBranches);

            // Геолокация недоступна
            if (!userGeoLocation || typeof userGeoLocation !== 'string') {
              return null; // кнопка всё равно появится через auto-submit effect
            }

            if (!isInRange) {
              return (
                <div className={styles.outOfRangeWarning}>
                  <div className={styles.warningIcon}>⚠</div>
                  <div>
                    <div className={styles.warningTitle}>Оператор вне зоны действия отметки</div>
                    <div className={styles.warningText}>{distanceInfo}</div>
                    <div className={styles.warningSubtext}>{config.outOfRangeMsg}</div>
                  </div>
                </div>
              );
            }

            return (
              <>
                {distanceInfo && (
                  <div style={{ color: 'green', marginBottom: 8, fontWeight: 'bold' }}>
                    Ближайший филиал: {distanceInfo}
                  </div>
                )}
                <button onClick={onConfirm} disabled={confirmLoading} className={styles.btn_tabel_driver}>
                  {confirmLoading ? 'Отправка...' : 'Подтвердить получение'}
                </button>
              </>
            );
          })()}
          {confirmError && <div style={{ color: 'red' }}>{confirmError}</div>}
        </div>
      )}
    </>
  );
};

export default React.memo(OperatorDriverPanel);
